import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { noindexHead } from "@/lib/seo";

const searchSchema = z.object({
  session_id: z.string(),
  creator_id: z.string(),
});

export const Route = createFileRoute("/checkout/redirect")({
  component: RouteComponent,
  validateSearch: searchSchema,
  head: () => noindexHead("Checkout | Lutely"),
});

function RouteComponent() {
  return null;
  // TODO: I'm pretty sure this entire file is deprecated now with the new checkout flow
  // const hasRunRef = useRef(false);
  // const [message, setMessage] = useState("Processing your order...");
  // const { getNextCheckoutUrl, clearCart } = useCartManager();
  // const checkoutSession = useCheckoutControllerFulfillCheckoutSession();

  // const navigate = Route.useNavigate();
  // const { session_id, creator_id } = Route.useSearch();

  // useEffect(() => {
  //   if (hasRunRef.current) return;

  //   if (session_id && creator_id) {
  //     hasRunRef.current = true;
  //     checkoutSession
  //       .mutateAsync({
  //         sessionId: session_id,
  //         // TODO: This was giving a typescript warning, I don't think this code is even going to be called anymore
  //         // params: { creatorId: creator_id },
  //       })
  //       .then(() => {
  //         const nextUrl = getNextCheckoutUrl();
  //         if (nextUrl) {
  //           setMessage("Redirecting to your next purchase...");
  //           setTimeout(() => {
  //             window.location.href = nextUrl.checkoutUrl;
  //           }, 2000);
  //         } else {
  //           toast.success("Your purchases are now available for download!", {
  //             toastId: "purchases_available_for_download",
  //           });
  //           clearCart();
  //           navigate({ to: "/account/purchases" });
  //         }
  //       })
  //       .catch((error) => {
  //         setMessage(getErrorMessage(error));
  //       });
  //   }
  // }, [
  //   session_id,
  //   creator_id,
  //   checkoutSession,
  //   getNextCheckoutUrl,
  //   clearCart,
  //   navigate,
  // ]);

  // return (
  //   <Flex
  //     className="h-screen mt-[-60px] items-center justify-center"
  //     direction="column"
  //   >
  //     <Spinner size="3" />
  //     <Text className="mt-[15px] font-bold">{message}</Text>

  //     {/*TODO */}
  //     {/* Integrate embeded checkout flow for a more seamless experience */}
  //   </Flex>
  // );
}
